import { CeruleanButton } from 'components/Button'
import messages from 'lang'
import React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'

import Container from '../Modal/Container'

const Success = ({ intl }: WrappedComponentProps) => (
  <Container
    sub={intl.formatMessage(messages.sub_title_success_2fa)}
    title={intl.formatMessage(messages.title_success_2fa)}
  >
    <CeruleanButton e2e='gotItButton' type='submit'>
      {intl.formatMessage(messages.button_got_it)}
    </CeruleanButton>
  </Container>
)

export default injectIntl(Success)
